"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _consts = require("../consts.js");
var _ProviderIntent = _interopRequireDefault(require("../components/ProviderIntent.js"));
var _providerEvents = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/providerEvents"));
var _mobileViewTypes = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/mobileViewTypes"));
var _WixSDKProviderApi = _interopRequireDefault(require("../components/WixSDKProviderApi"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable react/prop-types, no-case-declarations */
var FullScreenShop = /*#__PURE__*/function (_Component) {
  function FullScreenShop(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      providerShopHeight: null
    };
    _this.onIframeLoaded = _this.onIframeLoaded.bind(_this);
    _this.sendItemData = _this.sendItemData.bind(_this);
    return _this;
  }
  (0, _inheritsLoose2["default"])(FullScreenShop, _Component);
  var _proto = FullScreenShop.prototype;
  _proto.postShopRequest = function postShopRequest(type, data) {
    if (this.shopIntent) {
      this.shopIntent.postMessage(type, data);
    }
  };
  _proto.addToCartRequest = function addToCartRequest() {
    if (this.shopIntent) {
      this.shopIntent.postMessage(_providerEvents["default"].addToCartRequest, {});
    }
  };
  _proto.sendItemData = function sendItemData(item) {
    if (item && item.getDataForShop) {
      this.shopIntent.postMessage(_providerEvents["default"].itemChanged, item.getDataForShop());
    }
  };
  _proto.componentWillUpdate = function componentWillUpdate(nextProps) {
    var item = nextProps.item;
    if (item) {
      if (this.shopIntent) {
        if (this.props.item && this.props.item.id !== item.id) {
          this.sendItemData(item);
        }
      }
    }
  };
  _proto.onIframeLoaded = function onIframeLoaded() {
    var item = this.props.item;
    if (item) {
      if (this.shopIntent) {
        this.sendItemData(item);
      }
    }
  };
  _proto.messageReceived = function messageReceived(type, payload, resolve, reject, providerId) {
    var _this$props = this.props,
      galleryId = _this$props.galleryId,
      styleId = _this$props.styleId,
      pageId = _this$props.pageId,
      storeApi = _this$props.storeApi,
      connectedProviders = _this$props.connectedProviders,
      toggleShopEditorPage = _this$props.toggleShopEditorPage,
      _this$props$item = _this$props.item,
      url = _this$props$item.url,
      isDemo = _this$props$item.isDemo,
      isOOI = _this$props.isOOI;
    switch (type) {
      case _providerEvents["default"].sdkReady:
        this.sendItemData(this.props.item);
        console.time('Provider items load time');
        break;
      case _providerEvents["default"].addToCart:
        var uuid = payload.uuid,
          quantity = payload.quantity,
          metadata = payload.metadata;
        storeApi.addToCart({
          uuid: uuid,
          itemUrl: url,
          galleryId: galleryId,
          providerId: providerId,
          quantity: quantity,
          isDemo: isDemo,
          metadata: metadata,
          styleId: styleId
        });
        resolve();
        break;
      case _providerEvents["default"].setHeight:
        if (payload.height !== this.state.providerShopHeight) {
          this.setState({
            providerShopHeight: payload.height
          });
        }
        resolve();
        break;
      case _providerEvents["default"].close:
        this.props.toggleMobileShopFrame();
        break;
      case _providerEvents["default"].setMobileProductData:
        this.props.onSetMobileData(payload.type, payload.data);
        console.timeEnd('Provider items load time');
        break;
      case _providerEvents["default"].setDefaultPrice:
        var priceData = payload;
        this.props.onSetMobileData(_mobileViewTypes["default"].singleProduct, priceData);
        break;
      case _providerEvents["default"].openModal:
        var options = payload.options,
          name = payload.name;
        if (isOOI) {
          var provider = Object.keys(connectedProviders)[0];
          var providerData = connectedProviders[provider];
          var widgets = providerData.widgets;
          if (widgets[name] && [_consts.providerIntents.editor].includes(name)) {
            toggleShopEditorPage((0, _extends2["default"])({}, options, options.urlParams, {
              name: name
            }));
            resolve();
            break;
          }
        }
        storeApi.openProviderModal({
          name: name,
          connectedProviders: connectedProviders,
          options: options,
          containerParams: {
            galleryId: galleryId,
            itemUrl: url,
            isDemo: isDemo,
            styleId: styleId,
            pageId: pageId
          }
        });
        resolve();
        break;
      case _providerEvents["default"].updateCartItem:
        storeApi.updateCartItem({
          uuid: payload.uuid,
          metadata: payload.metadata,
          quantity: payload.quantity
        });
        break;
      case _providerEvents["default"].clearCart:
        storeApi.clearCart();
        break;
      case _providerEvents["default"].removeFromCart:
        storeApi.removeFromCart({
          uuid: payload.uuid
        });
        break;
      case _providerEvents["default"].getCartItems:
        var items = this.props.cartItemsData.cartItems || [];
        resolve(items);
        break;
      default:
        break;
    }
  };
  _proto.getShopHeight = function getShopHeight(isMobile) {
    var providerShopHeight = this.state.providerShopHeight;
    var storeHeight = this.props.storeHeight;
    var height = providerShopHeight ? Math.min(storeHeight, providerShopHeight) : storeHeight;
    return isMobile ? '100%' : height + 'px';
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      wixSdk = _this$props2.wixSdk,
      additionalProviderParams = _this$props2.additionalProviderParams,
      item = _this$props2.item,
      galleryId = _this$props2.galleryId,
      isMobile = _this$props2.isMobile,
      consentPolicy = _this$props2.consentPolicy;
    var customAdditionalParams = {};
    consentPolicy && (customAdditionalParams.consentPolicy = consentPolicy);
    if (additionalProviderParams) {
      var srcId = additionalProviderParams.srcId,
        appDefId = additionalProviderParams.appDefId,
        isAlbumStore = additionalProviderParams.isAlbumStore,
        pricelistId = additionalProviderParams.pricelistId;
      srcId && (customAdditionalParams.srcId = srcId);
      pricelistId && (customAdditionalParams.pricelistId = pricelistId);
      appDefId && (customAdditionalParams.appDefId = appDefId);
      isAlbumStore && (customAdditionalParams.isAlbumsStore = isAlbumStore);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "full-screen-shop",
      style: {
        height: this.getShopHeight(isMobile)
      }
    }, /*#__PURE__*/_react["default"].createElement(_ProviderIntent["default"], (0, _extends2["default"])({
      api: new _WixSDKProviderApi["default"](wixSdk),
      ref: function ref(r) {
        return _this2.shopIntent = r;
      },
      intent: _consts.providerIntents.shop,
      tabIndex: 0,
      customAdditionalParams: customAdditionalParams,
      onMessageReceived: function onMessageReceived(type, payload, resolve, reject, providerId) {
        _this2.messageReceived(type, payload, resolve, reject, providerId);
      },
      additionalParams: (0, _extends2["default"])({}, item.getDataForShop(), {
        galleryId: galleryId
      }),
      onIframeLoaded: this.onIframeLoaded
    }, this.props)));
  };
  return FullScreenShop;
}(_react.Component);
/* eslint-enable react/prop-types, no-case-declarations */
var _default = exports["default"] = FullScreenShop;